import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';

export const selectVersion = createSelector(
  (state: RootState) => state.ui.version,
  version => version,
);

export const selectFeedbacks = createSelector(
  (state: RootState) => state.ui.allFeedbacks,
  feedbacks => feedbacks,
);

export const selectLang = createSelector(
  (state: RootState) => state.auth.profile?.lang ?? undefined,
  lang => lang,
);

export const selectVisibleGuide = createSelector(
  (state: RootState) => state.ui.visibleGuide,
  visibleGuide => visibleGuide,
);

export const selectMapType = createSelector(
  (state: RootState) => state.ui.mapType,
  mapType => mapType,
);

export const selectTheme = createSelector(
  (state: RootState) => state.ui.themeMode,
  theme => theme,
);
